import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export function AuthCard({ title, subtitle, brand, children, footer, testid = "auth-card" }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-md animate-fade-up" data-testid={testid}>
        <Link to="/login" className="flex items-center gap-2.5 mb-8" data-testid="auth-card-brand">
          {brand?.logo_url ? (
            <img src={brand.logo_url} alt={brand.name} className="h-10 max-w-[140px] object-contain rounded-md" />
          ) : (
            <div className="h-10 w-10 rounded-xl bg-primary flex items-center justify-center shadow-sm"><Home className="h-5 w-5 text-primary-foreground" /></div>
          )}
          <div className="font-display font-extrabold text-xl tracking-tight text-slate-900">{brand?.name || "VuZuRent"}</div>
        </Link>
        <div className="rounded-2xl border border-slate-200 bg-white p-7 sm:p-8">
          <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-2 leading-relaxed">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="text-center text-sm text-slate-500 mt-5">{footer}</div>}
      </div>
    </div>
  );
}
